// extracted by mini-css-extract-plugin
export default {"backdrop":"Dialog_backdrop__-mkSh","container":"Dialog_container__qT5IE","header":"Dialog_header__tw0oD","body":"Dialog_body__gMcB3"};